import React from 'react';

import { useAuth } from '../../../shared/hooks';
import { WorkspaceLayout } from '../../shared/components/Layout';
import CancelMenu from './components/CancelMenu';
import CancelNotice from './components/CancelNotice';
import ResumeSubscriptionMenu from './components/ResumeSubscriptionMenu';
import { useBilling } from './hooks';

const Billing = () => {
  const { user } = useAuth();

  const { account, cancelSubscription, isLoading, isSubmitting, resumeSubscription } =
    useBilling();

  if (isLoading || !account) {
    return null;
  }

  const {
    cancelable: isCancelable,
    cancelAt,
    canceled: isCanceled,
    currentPeriodEndAt,
    pendingCancellation: isPendingCancellation,
  } = account;

  const isOwner = user.isOwner;

  return (
    <WorkspaceLayout>
      {/* TODO: Remove when the reactivation flow has been added. */}
      {isCanceled && <CancelNotice />}

      {isPendingCancellation && (
        <ResumeSubscriptionMenu
          cancelAt={cancelAt}
          canManage={isOwner}
          isSubmitting={isSubmitting}
          onResume={resumeSubscription}
        />
      )}

      {isCancelable && isOwner && (
        <CancelMenu
          currentPeriodEndAt={currentPeriodEndAt}
          onCancel={cancelSubscription}
        />
      )}
    </WorkspaceLayout>
  );
};

export default Billing;
